"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Activity$ = exports.loadLastUserActivity = exports.activityChange = exports.Users$ = void 0;
var effector_1 = require("effector");
var QBAdapter = __importStar(require("../QBAdapter"));
var findUsersByFilter_1 = __importDefault(require("./findUsersByFilter"));
var findUsersByIds_1 = __importDefault(require("./findUsersByIds"));
var loadUserById_1 = __importDefault(require("./loadUserById"));
exports.Users$ = effector_1.createStore({});
exports.activityChange = effector_1.createEvent();
exports.loadLastUserActivity = effector_1.createEvent();
exports.loadLastUserActivity.watch(function (userId) {
    QBAdapter.loadLastUserActivity(userId);
});
exports.Activity$ = effector_1.createStore({});
exports.Activity$.on(exports.activityChange, function (state, _a) {
    var _b;
    var userId = _a.userId, seconds = _a.seconds;
    return __assign(__assign({}, state), (_b = {}, _b[userId] = seconds, _b));
});
var listToMap = function (list) {
    return list.reduce(function (acc, user) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[user.id] = user, _a));
    }, {});
};
exports.Users$.on(findUsersByFilter_1.default.done, function (state, _a) {
    var result = _a.result;
    var map = listToMap(result);
    return __assign(__assign({}, state), map);
});
exports.Users$.on(loadUserById_1.default.done, function (state, _a) {
    var _b;
    var result = _a.result, qbUserId = _a.params;
    return __assign(__assign({}, state), (_b = {}, _b[qbUserId] = result, _b));
});
exports.Users$.on(findUsersByIds_1.default.done, function (state, _a) {
    var userList = _a.result;
    var map = listToMap(userList);
    return __assign(__assign({}, state), map);
});
//# sourceMappingURL=index.js.map